import { render, staticRenderFns } from "./cms-block-renderer.vue?vue&type=template&id=5497f643&scoped=true"
import script from "./cms-block-renderer.vue?vue&type=script&lang=js"
export * from "./cms-block-renderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5497f643",
  null
  
)

export default component.exports